import { render } from "./GameSubmitted.vue?vue&type=template&id=2a82e13d&scoped=true"
import script from "./GameSubmitted.vue?vue&type=script&lang=js"
export * from "./GameSubmitted.vue?vue&type=script&lang=js"

import "./GameSubmitted.vue?vue&type=style&index=0&id=2a82e13d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a82e13d"]])

export default __exports__